export let tableHeader = [{
		text: "Id",
		value: "id",
		align: "left"
	},
	{
		text: "Názov",
		value: "name",
		align: "left"
	},
	{
		text: "Popis",
		value: "description",
		align: "left"
	},
	{
		text: "Stav",
		value: "manufacturingCommandStatus",
		align: "left"
	},
	{
		text: "Zadaný do výroby",
		value: "startTime",
		align: "left"
	},
	{
		text: "Konečný čas",
		value: "finishTime",
		align: "left"
	},
	{
		text: "Akcie",
		value: "action",
		align: "left",
		sortable: false
	},
	{
		text: "Vytvorený",
		value: "created",
		align: "right"
	}
]

export let tableHeaderDetail = [{
		text: "Id",
		value: "id",
		align: "left"
	},
	{
		text: "Materiál",
		value: "storageCard",
		align: "left"
	},
	{
		text: "Pracovisko",
		value: "workplace",
		align: "left"
	},
	{
		text: "Hodnota",
		value: "value",
		align: "left"
	},
	{
		text: "Merná jednotka",
		value: "unitOfMeasure",
		align: "left"
	},
	{
		text: "Stav",
		value: "state"
	},
	{
		text: "",
		value: "action",
		sortable: false
	}
]

export let orderDetailsTableHeader = [{
		text: "Id",
		value: "orderDetailId",
		align: "left"
	},
	{
		text: "Číslo objednávky",
		value: "orderId",
		align: "left"
	},
	{
		text: "Počet",
		value: "quantity",
		align: "left"
	},
	{
		text: "Spracovaná",
		value: "produce",
		align: "left"
	},
	{
		text: "Číslo skladovej karty",
		value: "storageCardId",
		align: "left"
	},
	{
		text: "Skladová karta",
		value: "storageCard",
		align: "left"
	},
]

export let commandUpdateTableHeader = [{
		text: 'Dessert (100g serving)',
		align: 'left',
		sortable: false,
		value: 'name',
	},
	{
		text: 'Calories',
		value: 'calories'
	},
	{
		text: 'Fat (g)',
		value: 'fat'
	},
	{
		text: 'Carbs (g)',
		value: 'carbs'
	},
	{
		text: 'Protein (g)',
		value: 'protein'
	},
	{
		text: 'Iron (%)',
		value: 'iron'
	},
]